import React, { useState, useEffect } from 'react';
import { Button } from 'primereact/button';

const ScrollToAnchor = (props) => {

  const [anchorTarget, setAnchorTarget] = useState(null);

  useEffect(() => {
    const element = document.getElementById(props.btnId);
    setAnchorTarget(element);
  }, [props.btnId]);

  useEffect(() => {
    if (anchorTarget && props.redirect) {
      try {
        anchorTarget.scrollIntoView({ behavior: 'smooth', block: 'center' });
      } catch (error) {
        console.warn('Scroll error:', error);
      }
    }
  }, [props.redirect, anchorTarget]);

  const handleClick = event => {
    event.preventDefault();
    
    const currentTarget = document.getElementById(props.btnId);
    
    if (currentTarget) {
      try {
        currentTarget.scrollIntoView({ behavior: 'smooth', block: 'center' });
      } catch (error) {
        console.warn('Scroll error:', error);
      }
    } else {
      console.warn(`Element with id "${props.btnId}" not found`);
    }
  };

  return (
    props.type == 'button' ? <a href={`#${props.btnId}`}
      onClick={handleClick}
      aria-label={`Scroll to ${props.btnId}`}
      style={{ textDecoration: 'none' }}
      >
      {props.onClick ? <Button label={props.label} icon={props.icon} type="button" onClick={props.onClick} className={props.className} /> : <Button label={props.label} type="button" className={props.className} />}
    </a>
      :
      <a href={`#${props.btnId}`}
        onClick={handleClick}
        className={props.className}
        ariaLabel={`Scroll to ${props.btnId}`}>
        {props.label}
      </a>
  );
};

export default ScrollToAnchor;